const specialCharsRegex = /<|>|\/||\||\?|\(|\)|'|:|;/g;

export const filterSpecialChars = (str, isPasswordField = false) => {
    if (typeof str === 'string' && !isPasswordField && str !== '') {
        return str?.replace(specialCharsRegex, '').toString();
    }
    return str;
};

export const filterScriptTag = (str) => {
    if (str) {
        return str.replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    return str;
};

export const formatPhoneNumber = (phone_number) => phone_number.replace(/^(0|62)(?=\d)/, '+62');

export default {
    filterSpecialChars,
    filterScriptTag,
    formatPhoneNumber,
};
